"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionTypeObserverMiddleware = exports.actionTypeSubject$ = void 0;
var rxjs_1 = require("rxjs");
/**
 * rxjs Subject to be observed for latest action type triggered within redux
 */
exports.actionTypeSubject$ = new rxjs_1.Subject();
/**
 * Simple middleware to broadcast triggered action type to rxjs Subject observable
 */
var actionTypeObserverMiddleware = function () { return function (next) { return function (action) {
    exports.actionTypeSubject$.next(action);
    return next(action);
}; }; };
exports.actionTypeObserverMiddleware = actionTypeObserverMiddleware;
//# sourceMappingURL=middleware.js.map